import { render, staticRenderFns } from "./LinkUserCardForm.vue?vue&type=template&id=0cab5547&"
import script from "./LinkUserCardForm.vue?vue&type=script&lang=js&"
export * from "./LinkUserCardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports